<script>
	import CustomSearch from "src/components/CustomSearch/CustomSearch.svelte";
	import DamageCarousel from "src/components/ReportCard/DamageCarousel.svelte";
	import { convert, sveltyPickerFormat } from "src/services/helpers";
	import { collisionTypeOptions } from "src/utils/options";
	import { Col, Row } from "@sveltestrap/sveltestrap";
	import SveltyPicker from "svelty-picker";
	import DamageInformationAttribution from "./DamageInformationAttribution.svelte";
	import DamageInformation from "./DamageInformation.svelte";
	import DamageInformationVqp from "./DamageInformationVqp.svelte";

	export let caseDetails = {};
	export let incidentDateTime;
	export let form;
	export let state;
	export let damageCauseType;
	export let attribution;
	export let damageCause;
	export let staffName;
	export let staffContact;
	export let thirdPartyName;
	export let thirdPartyContact;
	export let vqp;
	export let bidError = "";
</script>

<div class="p-0">
	<Row>
		{#if caseDetails.attribution === "User"}
			<Col>
				<div class="description">Booking ID</div>
				<div class="value">
					{caseDetails.bookingNo}
				</div>
			</Col>
			<Col>
				<div class="description">Actual Booking Start Time</div>
				<div class="value">
					{convert(caseDetails.bookingStartTime)}
				</div>
			</Col>
			<Col>
				<div class="description">Actual Booking End Time</div>
				<div class="value">
					{convert(caseDetails.bookingEndTime)}
				</div>
			</Col>
		{:else}
			<Col>
				<div class="description">Booking ID & Report Type</div>
				<div class="value">
					Unknown ({caseDetails.bookingReportType})
				</div>
			</Col>
		{/if}
	</Row>

	{#if caseDetails.status !== "Quoting" && state === "view"}
		<hr class="divider" />
		<Row>
			<Col xs={4}>
				<div class="description">Incident Date & Time</div>
				<div class="value">{convert(caseDetails.incidentDateTime)}</div>
			</Col>
			<Col xs={4}>
				<div class="description">Attributed To</div>
				<div class="value">{caseDetails.attribution || "-"}</div>
			</Col>
			<Col xs={4}>
				<div class="description">Type Of Collision</div>
				<div class="value">
					{caseDetails.collisionType || "-"}
				</div>
			</Col>
		</Row>
		<hr class="divider" />
		<Row>
			{#if caseDetails.attribution === "Staff"}
				<Col xs={4}>
					<div class="description">Staff Name</div>
					<div class="value">
						{caseDetails.staffName || "-"}
					</div>
				</Col>
				<Col xs={4}>
					<div class="description">Staff Contact No</div>
					<div class="value">
						{caseDetails.staffContact || "-"}
					</div>
				</Col>
			{:else if caseDetails.attribution === "ThirdParty"}
				<Col xs={4}>
					<div class="description">Third Party Name</div>
					<div class="value">
						{caseDetails.thirdPartyName || "-"}
					</div>
				</Col>
				<Col xs={4}>
					<div class="description">Third Party Contact No</div>
					<div class="value">
						{caseDetails.thirdPartyContact || "-"}
					</div>
				</Col>
			{/if}
			<Col xs={4}>
				<div class="description">VQP</div>
				<div class="value">
					{caseDetails.vqp ?? "-"}
				</div>
			</Col>
		</Row>
	{/if}

	{#if caseDetails.bookingImages?.length > 0}
		<hr class="divider" />
		<Row>
			<Col>
				<DamageCarousel
					data={{ images: caseDetails.bookingImages }}
					lightbox={true}
				/>
			</Col>
		</Row>
	{/if}

	{#if state === "edit" || state === "create" || caseDetails.status === "Quoting"}
		<hr class="divider" />
		<Row class="mb-4">
			<Col xs={4}>
				<Row>
					<Col>
						<label for="dateReported" class="d-block">
							<span>
								Incident Date and Time<span class="text-danger"
									>*</span
								>
							</span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col>
						<SveltyPicker
							inputClasses="form-control getgo input calendar-icon"
							format={sveltyPickerFormat}
							placeholder="Select a date and time"
							bind:value={$incidentDateTime.value}
							disableDatesFn={(date) => {
								const today = new Date();
								return date > today;
							}}
						/>
						{#if new Date($incidentDateTime.value) > new Date()}
							<div class="text-danger mt-1">
								Incident date cannot be in the future
							</div>
						{/if}
					</Col>
				</Row>
			</Col>
		</Row>
		<Row>
			<Col xs={9}>
				<DamageInformationAttribution
					{attribution}
					{damageCause}
					{damageCauseType}
					{staffName}
					{staffContact}
					{thirdPartyName}
					{thirdPartyContact}
					{form}
					{bidError}
				/>
			</Col>
		</Row>
		<Row class="mb-4">
			<Col xs={4}>
				<Row>
					<Col>
						<label for="collisionType" class="d-block">
							<span>
								Type of collision<span class="text-danger"
									>*</span
								>
							</span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col>
						<CustomSearch
							isSearchable={false}
							items={collisionTypeOptions}
							placeholder="Select collision type"
							bind:value={$damageCauseType.value}
							error={$form.hasError("damageCauseType.required")}
							errorText="Collision type is required"
						/>
					</Col>
				</Row>
			</Col>
		</Row>
		<DamageInformationVqp {vqp} {caseDetails} />
	{/if}
</div>
